import { render, staticRenderFns } from "./PurchaseDetail.vue?vue&type=template&id=09318fe6&scoped=true"
import script from "./PurchaseDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDetail.vue?vue&type=style&index=0&id=09318fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09318fe6",
  null
  
)

export default component.exports